import type { z } from 'zod';
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';
import { saveReviewResponseDataSchema } from '../saveReview/save-review-response';

export const saveReviewV2ResponseDataSchema = saveReviewResponseDataSchema;

export type ISaveReviewV2ResponseData = z.infer<typeof saveReviewV2ResponseDataSchema>;

export const saveReviewV2ResponseSchema = createApiResponseSchema(
  saveReviewV2ResponseDataSchema,
) as z.ZodSchema<IAPI<ISaveReviewV2ResponseData>>;

export type ISaveReviewV2Response = IAPI<ISaveReviewV2ResponseData>;
